const UNSUBSCRIBED_PREFERENCE = 'UNSUBSCRIBED';
const STORAGE_KEY = 'dismissedGDPRBanner';
const CONSUMER_GRADIENTS = ['coursera', 'lightBlue', 'peach', 'kiwi', 'sea', 'blueberry', 'grape'] as const;
const ENTERPRISE_GRADIENTS = ['grape'] as const;

const exported = {
  UNSUBSCRIBED_PREFERENCE,
  STORAGE_KEY,
  CONSUMER_GRADIENTS,
  ENTERPRISE_GRADIENTS,
} as const;

export default exported;
export { UNSUBSCRIBED_PREFERENCE, STORAGE_KEY, CONSUMER_GRADIENTS, ENTERPRISE_GRADIENTS };
